import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { VideoCategoryDto, VideoDto } from './types';

export interface VideoListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 分类ID（0-全部） */
  cateId?: number;
  /** 医师ID（0-全部） */
  doctorId?: number;
  /** 名称搜索 */
  name?: string;
}

/** 视频列表（/video/userGetVideoList，公开接口） */
export function fetchVideoList(options: VideoListOptions = {}): Promise<PagedList<VideoDto>> {
  const { pageIndex = 1, pageSize = 10, cateId = 0, doctorId = 0, name = '' } = options;

  return request(
    '/video/userGetVideoList',
    buildListParams({
      pageIndex,
      pageSize,
      // 与小程序一致：视频列表不过滤启用状态
      state: 0,
      name,
      extra: {
        checkState: 0,
        cateId,
        doctorId,
        minBrowseCount: 0,
        maxBrowseCount: 0,
      },
    }),
  );
}

/** 视频详情（/video/userGetVideoInfo，公开接口） */
export function fetchVideoInfo(id: number): Promise<DataInfoResponse<VideoDto>> {
  return request('/video/userGetVideoInfo', { id });
}

/** 视频分类（/video/userGetVideoCateList，公开接口） */
export function fetchVideoCateList(): Promise<PagedList<VideoCategoryDto>> {
  return request(
    '/video/userGetVideoCateList',
    buildListParams({
      pageIndex: 1,
      pageSize: 999,
      state: 1,
      name: '',
      extra: { layer: 0, isShow: 1, parentId: 0 },
    }),
  );
}
